import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const ChooseView = ({ views, view, onChangeView }) => {
    return (
        <FormControl size="small">
            <InputLabel id="view-label">View</InputLabel>
            <Select
                labelId="view-label"
                id="view"
                value={view}
                label="View"
                onChange={e => onChangeView(e.target.value)}
            >
                {views.map((e, i) => <MenuItem value={e.name} key={i}>{e.label}</MenuItem>)}
            </Select>
        </FormControl>
    );
};

export default ChooseView;